import Cutoff from './Cutoff'

export default Cutoff



// WEBPACK FOOTER //
// ./src/containers/Modals/Cutoff/index.js